import { render, staticRenderFns } from "./BoxStatusWinEdit.vue?vue&type=template&id=0b3d3b63&scoped=true&"
import script from "./BoxStatusWinEdit.vue?vue&type=script&lang=js&"
export * from "./BoxStatusWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./BoxStatusWinEdit.vue?vue&type=style&index=0&id=0b3d3b63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d3b63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3d3b63')) {
      api.createRecord('0b3d3b63', component.options)
    } else {
      api.reload('0b3d3b63', component.options)
    }
    module.hot.accept("./BoxStatusWinEdit.vue?vue&type=template&id=0b3d3b63&scoped=true&", function () {
      api.rerender('0b3d3b63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BoxStatusWinEdit.vue"
export default component.exports